import { render, staticRenderFns } from "./RakutenLogin.vue?vue&type=template&id=1643aa65&scoped=true&"
import script from "./RakutenLogin.vue?vue&type=script&lang=js&"
export * from "./RakutenLogin.vue?vue&type=script&lang=js&"
import style0 from "./RakutenLogin.vue?vue&type=style&index=0&id=1643aa65&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1643aa65",
  null
  
)

export default component.exports